import { createContext, useState, useEffect, useMemo } from 'react';
import Passwordless from './Passwordless';
import Login from './Login';
import Register from './Register';

type LoginVariant = 'login' | 'register' | 'passwordless';

interface LoginFormModalProps {
    visible: boolean;
    onCancel: () => void;
    type: LoginVariant;
    isRegister?: boolean;
    /** 登录成功后的回调，如果传入则不会跳转页面 */
    onSuccess?: () => void;
}

type LoginContextValue = { type: LoginVariant; setType: (type: LoginVariant) => void };
export const LoginContext = createContext<LoginContextValue | null>(null);

export default function LoginFormModal({ visible, onCancel, type: propType, isRegister, onSuccess }: LoginFormModalProps) {
    const [type, setType] = useState<LoginVariant>(propType);

    useEffect(() => {
        setType((prev) => (prev === propType ? prev : propType));
        // setType('register');
    }, [propType]);

    const contextValue = useMemo(() => ({ type, setType }), [type]);

    if (!visible || !type) return null;

    return (
        <LoginContext.Provider value={contextValue}>
            <style jsx global>
                {`
                    .ant-message {
                        z-index: 9999999 !important;
                    }
                `}
            </style>
            {type === 'login' && <Login visible={visible} onCancel={onCancel} />}
            {type === 'register' && <Register visible={visible} onCancel={onCancel} onSuccess={onSuccess} />}
            {type === 'passwordless' && <Passwordless visible={visible} onCancel={onCancel} isRegister={isRegister} onSuccess={onSuccess} />}
        </LoginContext.Provider>
    );
}
